import { registerPlugin } from '@capacitor/core';

import type { WidgetPlugin } from './definitions';

const Widget = registerPlugin<WidgetPlugin>('Widget', {
	web: () => import('./web').then(m => new m.WidgetWeb()),
});

export * from './definitions';
export { Widget };
